import { AtomicSearch } from '@components/Search/AtomicSearch';
import { useFlags } from '@lib/flags/amplitude/client';
import { FLAG_TREATMENT, Flags } from '@lib/flags/flagConstants';
import { HeaderSearch } from './Search';

/* Handles returning either the old Search or the Atomic Coveo Searchbox */
export const SearchWrapper = ({
  searchPlaceholder,
}: {
  searchPlaceholder: string;
}) => {
  const { flags, loading } = useFlags();
  const isCoveoSearchEnabled =
    flags?.[Flags.COVEO_SEARCH]?.value === FLAG_TREATMENT;

  if (loading) {
    return null;
  }

  if (isCoveoSearchEnabled) {
    return <AtomicSearch />;
  }

  return <HeaderSearch placeholder={searchPlaceholder} />;
};
